<template>
  <div class="diseaseList">
    <div class="tableList">
      <el-form ref="form" :model="dialogForm" label-width="100px">
        <el-form-item label="模版" required>
          <el-input v-model="dialogForm.type" clearable disabled placeholder="病历参数模版配置"></el-input>
        </el-form-item>

        <el-form-item label="参数配置" required>
          <div
            v-for="(item, index) in dialogForm.message"
            :key="index"
            style="display: flex; align-items: center"
          >
            <!-- <el-select
              v-model="item.type"
              placeholder="选择类型"
              clearable
              style="width: 150px; margin-right: 10px; margin-top: 10px"
            >
              <div v-for="(item, index) in typeList" :key="index">
                <el-option :label="item.name" :value="item.id"></el-option>
              </div>
            </el-select>-->
            <el-tag type="success" style="margin: 10px">字段中文描述:</el-tag>
            <el-input
              size="mini"
              v-model="item.keyName"
              placeholder="请输入"
              style="width: 30%; margin-right: 10px;"
            ></el-input>
            <el-tag type="success" style="margin: 10px">字段英文命名:</el-tag>
            <el-input
              size="mini"
              v-model="item.key"
              placeholder="请输入"
              style="width: 30%; margin-right: 10px;"
            ></el-input>

            <el-button
              class="cancelBtn"
              type="text"
              @click="handleDelete(index)"
              style="margin-right: 10px;;color:red"
            >删除</el-button>
          </div>
          <el-button
            class="addBtn"
            type="primary"
            @click="handleAddItem"
            style="margin-top: 10px"
          >+ 添加</el-button>
          <el-button
            type="primary"
            class="cancelBtn"
            @click="handleSave"
            style="margin-right: 10px;"
          >保存</el-button>
          <div class="note">问答ai会按照此步骤进行提问</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { selectApi, updateApi, deleteApi } from "@/services/sysPrompt/index";
import ElTable from "@/components/elTable/index.vue";
import StoreToString from "@/components/filters/storeToString.vue";
import listHeader from "./listHeader";
import { mapState } from "vuex";
import { arrayByIdToNameStr } from "@/utils/arrayByIdToNameStr";
export default {
  components: {
    ElTable,
    StoreToString
  },
  created() {
    this.getListData();
  },

  data() {
    return {
      listQuery: {
        type: "病历参数模版配置",
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },

      dialogForm: {
        type: "",
        message: []
      },

      tableData: [],

      arrayByIdToNameStr,
      cycleList: [],
      gzhList: [],
      loading: false,

      dialogFormVisible: false,
      inpitTypeName: "",

      dialogFormVisible_cycle: false
    };
  },
  computed: {
    listHeader,
    ...mapState(["userInfo", "filterStoreList"])
  },
  watch: {},
  methods: {
    async getListData() {
      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      listQuery.admin_id = this.userInfo.id;
      // listQuery.store_id?.join(",") || this.userInfo.store_id;
      this.loading = true;
      const { data, code, count } = await selectApi(listQuery);
      if (code === 200 && data.length > 0) {
        this.dialogForm = {
          ...data[0],
          message: JSON.parse(data[0].message) || []
        };
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },

    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },

    handleAddItem() {
      console.log("this.dialogForm.message", this.dialogForm.message);
      this.dialogForm.message.push({
        key: "",
        keyName: "",
        value: "提取的内容"
      });
    },

    handleDelete(index) {
      this.dialogForm.message.splice(index, 1);
    },

    handleSave() {
      //必填字段校验
      if (!this.dialogForm.message.every(item => item.keyName && item.key)) {
        this.$message.error("选项不能为空");
        return;
      }
      let message = this.dialogForm.message.map((item, index) => {
        return {
          ...item
        };
      });
      // console.log("message", message);
      if (!this.dialogForm.id) {
        updateApi({
          admin_id: this.userInfo.id,
          type: "病历参数模版配置",
          message: JSON.stringify(message)
        }).then(resp => {
          console.log(resp);
          if (resp.code == 200) {
            this.$message({
              type: "success",
              message: "保存成功!"
            });
            this.dialogFormVisible_cycle = false;
            this.getListData();
          }
        });
        return;
      }
      updateApi({
        id: this.dialogForm.id,
        message: JSON.stringify(message)
      }).then(resp => {
        console.log(resp);
        if (resp.code == 200) {
          this.$message({
            type: "success",
            message: "保存成功!"
          });
          this.dialogFormVisible_cycle = false;
          this.getListData();
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.diseaseList {
  width: 100%;
}
.tableList {
  border-radius: 6px;
  background: #fff;
  /* max-width: 1405px; */
  margin: 10px auto;
}

/* 时间卡片配置 */
.tags {
  display: flex;
  width: 100%;
  margin: 20px auto;
  > span {
    margin: 0 5px;
  }
  > span:hover {
    cursor: pointer;
  }
}
</style>
